import {RootState} from './index'

export const userSelector = (state: RootState) => state.user
export const loggedInSelector = (state: RootState) => state.user.loggedIn
export const projectsSelector = (state: RootState) => state.projects
export const navigationSelector = (state: RootState) => state.navigation
export const locationSelector = (state: RootState) => state.loginRedirect.location
export const appStateSelector = (state: RootState) => state.appState
